// extracted by mini-css-extract-plugin
export var datasourcesFullPage = "datasources-module--datasources-full-page--Z7+xR";